import {
  getGraphIDFromProductId,
  getShopifyProductsForCountry,
} from '../utils/retrieveShopifyProductsForSelectedCountry';

const getInternatioalData = async (idArr) => {
  let shopify_products = [];

  try {
    shopify_products = await getShopifyProductsForCountry(idArr);
  } catch (err) {
    console.error(err);
  }

  return shopify_products;
};

export default () => {
  const processMonetateData = async (monetateData, scheme, title) => {
    const graph_product_ids = monetateData.map((item) => getGraphIDFromProductId(item.item_group_id));
    for (let key = 0; key < monetateData.length; key++) {
      const item = monetateData[key];
      const colorOptions = [];

      if (item.Child_Attributes) {
        var tempstring = '';
        if (item.Child_Attributes.slice(-1) == ',') {
          tempstring = item.Child_Attributes.slice(0, -1);
        } else {
          tempstring = item.Child_Attributes;
        }

        const childAttributesArray = JSON.parse(tempstring);
        Array.isArray(childAttributesArray)
          ? (item.Child_Attributes = childAttributesArray)
          : (item.Child_Attributes = [childAttributesArray]);
        if (item.Child_Attributes) {
          item.Child_Attributes.forEach((variantItem) => {
            const existingColor = colorOptions.find((color) => color === variantItem.option1);
            if (!existingColor) {
              colorOptions.push(variantItem.option1);
            }
          });
        }
      }

      item.selectedColor = item.color;
      if (colorOptions.includes(item.selectedColor.toUpperCase())) {
        const index = colorOptions.indexOf(item.selectedColor.toUpperCase());
        colorOptions.splice(index, 1);
        colorOptions.unshift(item.selectedColor.toUpperCase());
      }

      item.color = [...colorOptions];
    }

    const eventName = `monetateLoaded${scheme}`;
    if (window.theme.country_iso !== 'US') {
      try {
        const internationData = await getInternatioalData(graph_product_ids);

        for (let key = 0; key < monetateData.length; key++) {
          const item = monetateData[key];

          const internationalItem = internationData.find((intitem) => intitem.id.includes(item.item_group_id));

          if (item.Child_Attributes) {
            for (const variantItem of item.Child_Attributes) {
              const intenationVariant = internationalItem.variants.find((intItem) =>
                intItem.id.includes(variantItem.variant_id),
              );
              variantItem.price = intenationVariant.price.amount;
              variantItem.compare_at_price = intenationVariant.compareAtPrice.amount;
              variantItem.inventory = intenationVariant.quantityAvailable;
            }
          }
        }

        const event = new window.CustomEvent(eventName, { detail: { monetateData, title } });
        document.dispatchEvent(event);
      } catch (error) {
        // Handle errors from getInternatioalData
        console.error('Error fetching international data:', error);
        const event = new window.CustomEvent(eventName, { detail: { monetateData, title } });
        document.dispatchEvent(event);
      }
    } else {
      const event = new window.CustomEvent(eventName, { detail: { monetateData, title } });
      document.dispatchEvent(event);
    }
  };

  window.monetateRecommendations = async function (data) {
    processMonetateData(
      data.resonance.schemes[0].items,
      data.resonance.schemes[0].scheme,
      data.resonance.schemes[0].explanation,
    );
  };
};
